export const getSessionState = ({ session }) => session;

export const userSelector = (state) => getSessionState(state).user;
export const publicIdSelector = (state) => getSessionState(state).publicId;
export const showNavBarSelector = (state) => getSessionState(state).showNavBar;
export const sessionErrorSelector = (state) => getSessionState(state).error;
export const sessionLoadingSelector = (state) => getSessionState(state).loading;
export const previousRouteSelector = (state) => getSessionState(state).previousRoute;
export const submittingMarketingConsentSelector = (state) => getSessionState(state).submittingMarketingConsent;
